import { zeroAddress } from 'viem'

import { addressSchema } from '~/components/smart-accounts/schemas/addressSchema'
import { Address } from '~/utils/address'

export const accountSchema = addressSchema.refine((address) => {
  if (!address || address.length === 0) return false
  if (Address.format(address) === zeroAddress) return false
  return true
})
